<template>
  <v-row>
    <v-col cols="12">
      <v-card color="grey lighten-5">
        <v-card-text class="pa-2">
          <v-row dense>
            <v-col :style="{color: $randomizeColorFromString(team.key)}" class="body-1 font-weight-bold" cols="12">
              {{ team.name }}
              <v-btn v-if="!$isReadOnlyUser" class="mt-n1" icon small @click="openTeamEdit">
                <v-icon size="16">mdi mdi-pencil</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-text-field v-if="surveyShare"
                            :value="link"
                            dense
                            hide-details
                            outlined readonly>
                <!--<template v-if="surveyShare" v-slot:append>
                  <div class="success--text caption">
                    <v-icon class="mr-1" color="success" size="13">mdi mdi-check</v-icon>
                    {{ $t('surveys.shared') }}
                  </div>
                </template>-->
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn :disabled="!$hasMatchingTenantRoles(['tenant_admin'])" :loading="loadingCopyLink" block
                     color="secondary" outlined
                     small
                     @click="onCopyLinkClick">{{ $t('surveys.copy_link') }}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn :disabled="!$isPaidTenant || !$hasMatchingTenantRoles(['tenant_admin'])"
                     :loading="loadingShareWithEmail" block
                     color="secondary"
                     outlined small @click="shareWithEmail">
                {{ $t('surveys.share_with_email') }}
                <plan-chip v-if="!$isPaidTenant" :plan="$t('tenants.statuses.PRO')" class="ml-2"/>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import surveyShareApi from "@/api/surveyshare";
import PlanChip from "@/components/Tenant/Reports/PlanChip";

export default {
  name: "TeamShareSurvey",
  components: {PlanChip},
  props: ['team', 'survey', 'surveyShares', 'getSurveyShares'],
  data() {
    return {
      shared: false,
      loadingShareWithEmail: false,
      loadingCopyLink: false,
    }
  },
  computed: {
    surveyShare() {
      return this.surveyShares.find(surveyShare => surveyShare?.teams.findIndex(t => t.key === this.team.key) > -1);
    },
    origin() {
      return window.location.origin;
    },
    link() {
      return this.getLink(this.surveyShare);
    }
  },
  methods: {
    getLink(surveyShare) {
      return `${this.origin}/public/#/s/${surveyShare.key}${this.$tenant}/${this.team.urlSafeName}`
    },
    openTeamEdit() {
      this.$emit('open-team', this.team);
    },
    async onCopyLinkClick() {
      this.loadingCopyLink = true;
      try {
        await this.copyLink();
      } catch (e) {
        console.error(e)
      }
      this.loadingCopyLink = false;
    },
    async copyLink() {
      if (this.surveyShare && this.surveyShare.key) {
        try {
          await this.$copyText(this.link);
          this.$showSuccessNotification(this.$t('surveys.link_copied'));
        } catch (e) {
          console.error(e);
        }

        return false;
      }
      const surveyShare = await surveyShareApi.createSurveyShare({
        name: this.team.name,
        surveyKey: this.survey.key,
        answerers: this.team?.answerers?.length || null,
        teams: [
          this.team,
        ]
      })

      //this.$emit('refresh-survey-shares');
      await this.getSurveyShares();

      try {
        if (this.$isPaidTenant) {
          await this.$copyText(this.getLink(surveyShare));
          this.$showSuccessNotification(this.$t('surveys.link_copied'));
        }

      } catch (e) {
        console.error(e);
      }
      this.shared = true;
    },
    async shareWithEmail() {
      /*if (this.surveyShare && this.surveyShare.key && this.surveyShare.sent) {
        return false;
      }*/

      if (!this.surveyShare) {
        this.loadingShareWithEmail = true;
        try {
          await this.copyLink();
        } catch (e) {
          console.error(e);
        }
      }

      this.$nextTick(() => {
        this.loadingShareWithEmail = false;
        if (!this.surveyShare) {
          return false;
        }
        this.$emit('share-with-email', this.surveyShare);

        this.shared = true;
      })
    },
  }
}
</script>

<style scoped>

</style>
